/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamClassRoomDisciplinesStatus200,
  GetApiV1ExamClassRoomDisciplinesStatus401,
  GetApiV1ExamClassRoomDisciplinesStatus500,
  GetApiV1ExamClassRoomDisciplinesStatusQueryResponse,
} from "../../types/examEvaluationController/GetApiV1ExamClassRoomDisciplinesStatus.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamClassRoomDisciplinesStatus200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ExamClassRoomDisciplinesStatus200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamClassRoomDisciplinesStatus401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamClassRoomDisciplinesStatus401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamClassRoomDisciplinesStatus500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamClassRoomDisciplinesStatus500>;

export const getApiV1ExamClassRoomDisciplinesStatusQueryResponseSchema = z.lazy(
  () => getApiV1ExamClassRoomDisciplinesStatus200Schema,
) as unknown as ToZod<GetApiV1ExamClassRoomDisciplinesStatusQueryResponse>;
